import axios from 'axios'
export const searchProductWithKey = async (key) => {
  const header = {
    headers: {
      Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ='
    }
  }
  const data = key
  const result = await axios.get(`https://es.sery.co.kr/product/_doc/${data}`, header)
  return result.data
}



// WEBPACK FOOTER //
// ./src/js/http.js